
eval("define(\'text!oroui/templates/loading-mask-view.html\',[],function () { return \'<div class=\"loader-overlay\"></div>\\n<div class=\"loader-frame well\">\\n    <div class=\"loader-content\">\\n        <%= _.__(loadingHint) %>\\n    </div>\\n</div>\\n\';});\n\n//# sourceURL=/text!oroui/templates/loading-mask-view.html");

